import type { JSX, VoidComponent } from "solid-js";

type SettingsPageHeaderProps = {
  title: string;
  description: string;
  actionSlot?: () => JSX.Element;
};

const SettingsPageHeader: VoidComponent<SettingsPageHeaderProps> = (props) => (
  <div class="flex items-center border-b border-subtle pb-4">
    <div>
      <h3 class="text-header-sm text-secondary uppercase">{props.title}</h3>
      <p class="text-header-xl text-primary">{props.description}</p>
    </div>

    {props.actionSlot?.()}
  </div>
);

export default SettingsPageHeader;
